'use client';

import { Box, BoxProps, Flex, Heading } from '@mezzoforte/forge';

function EntryWrapper({ children }: React.PropsWithChildren) {
  return (
    <Flex
      flex="1 0 auto"
      width={{ base: 320, sm: 350 }}
      maxWidth={{ base: 320, sm: 350 }}
      scrollSnapAlign={{ sm: 'center', md: 'start' }}
      paddingLeft={1}
      paddingBottom={2}
      _first={{ base: { marginLeft: 3 }, sm: { marginLeft: 1 } }}
      _last={{ base: { marginRight: 3 }, sm: { marginRight: 1 } }}
    >
      {children}
    </Flex>
  );
}

interface ScrollerComponentProps extends BoxProps {
  headingText: string;
  children: JSX.Element[];
}

export function ScrollerComponent({ children, headingText, ...props }: ScrollerComponentProps) {
  return (
    <Box
      overflow="hidden"
      width="100%"
      height="100%"
      {...props}
      data-test-id="scroller-container"
    >
      <Heading
        variant="h3"
        marginX={{ base: '1rem', md: 'auto' }}
        mb={3}
      >
        {headingText}
      </Heading>
      <Flex
        data-test-id="scroller-list"
        gap={3}
        paddingY={2}
        position="relative"
        scrollSnapType="x mandatory"
        overflowX="auto"
      >
        {children.map((el) => (
          <EntryWrapper key={el.key}>{el}</EntryWrapper>
        ))}
      </Flex>
    </Box>
  );
}
